// Generated from products/analytics/shared/custom/aliveByMistake/reports.ts; run analytics generate:site-runtime.
import { z } from "zod";
import { AliveByMistakeKeySchema } from "./context.gen";

const AliveByMistakeReportProjectIdSchema = z.uuid();
const AliveByMistakeReportCountSchema = z.number().nonnegative();

export const AliveByMistakeReportQuerySchema = z
  .strictObject({
    projectId: AliveByMistakeReportProjectIdSchema,
    from: z.iso.datetime({ offset: true }),
    to: z.iso.datetime({ offset: true }),
    release: AliveByMistakeKeySchema.optional(),
    includeQa: z.enum(["true", "false"]).default("false"),
  })
  .refine((q) => {
    const span = Date.parse(q.to) - Date.parse(q.from);
    return span > 0 && span <= 31 * 86400000;
  }, "Choose a positive date window of at most 31 days");
export type AliveByMistakeReportQuery = z.infer<typeof AliveByMistakeReportQuerySchema>;

export const AliveByMistakeReportResponseSchema = z.strictObject({
  from: z.date(),
  to: z.date(),
  release: z.string().nullable(),
  includeQa: z.boolean(),
  sample: z.strictObject({
    events: AliveByMistakeReportCountSchema,
    visitors: AliveByMistakeReportCountSchema,
    sessions: AliveByMistakeReportCountSchema,
    returningVisitors: AliveByMistakeReportCountSchema,
    firstReceivedAt: z.date().nullable(),
    lastReceivedAt: z.date().nullable(),
  }),
  launches: z.strictObject({
    requested: AliveByMistakeReportCountSchema,
    started: AliveByMistakeReportCountSchema,
    failed: AliveByMistakeReportCountSchema,
    cancelled: AliveByMistakeReportCountSchema,
    unobserved: AliveByMistakeReportCountSchema,
    retries: AliveByMistakeReportCountSchema,
    loadSamples: AliveByMistakeReportCountSchema,
    averageLoadMs: AliveByMistakeReportCountSchema.nullable(),
  }),
  waves: z
    .array(
      z.strictObject({
        wave: z.number().int().min(1).max(250),
        started: AliveByMistakeReportCountSchema,
        cleared: AliveByMistakeReportCountSchema,
        defeated: AliveByMistakeReportCountSchema,
        abandoned: AliveByMistakeReportCountSchema,
        unobserved: AliveByMistakeReportCountSchema,
        retries: AliveByMistakeReportCountSchema,
      }),
    )
    .max(250),
  choices: z
    .array(
      z.strictObject({
        name: z.string(),
        item: z.string(),
        outcome: z.string(),
        count: AliveByMistakeReportCountSchema,
      }),
    )
    .max(50),
  choiceGroups: AliveByMistakeReportCountSchema,
  weapons: z
    .array(
      z.strictObject({
        weaponId: AliveByMistakeKeySchema,
        activeMs: AliveByMistakeReportCountSchema,
        intervals: AliveByMistakeReportCountSchema,
      }),
    )
    .max(50),
  weaponGroups: AliveByMistakeReportCountSchema,
  play: z.strictObject({
    intervals: AliveByMistakeReportCountSchema,
    activeMs: AliveByMistakeReportCountSchema,
    playerKills: AliveByMistakeReportCountSchema,
    turretKills: AliveByMistakeReportCountSchema,
    damageTaken: AliveByMistakeReportCountSchema,
    reloads: AliveByMistakeReportCountSchema,
    cashEarned: AliveByMistakeReportCountSchema,
    cashSpent: AliveByMistakeReportCountSchema,
    goldEarned: AliveByMistakeReportCountSchema,
    goldSpent: AliveByMistakeReportCountSchema,
  }),
});
export type AliveByMistakeReport = z.infer<typeof AliveByMistakeReportResponseSchema>;
